import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-405fd9f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewStepWaypoints" }
const _hoisted_2 = { class: "NewStepWaypoints__form mb-6" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "NewStepWaypoints__title" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-500 select-none"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_7 = { class: "NewStepWaypoints__selected mt-3" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { class: "selected__title" }
const _hoisted_10 = { class: "mt-2 text-sm" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-user mr-2" }, null, -1))
const _hoisted_13 = { class: "block" }
const _hoisted_14 = { class: "flex items-center mt-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-mobile mr-3" }, null, -1))
const _hoisted_16 = { class: "block" }
const _hoisted_17 = { class: "flex items-center mt-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-map-marker-alt mr-3" }, null, -1))
const _hoisted_19 = { class: "block" }
const _hoisted_20 = {
  key: 0,
  class: "mt-2 font-semibold"
}
const _hoisted_21 = {
  key: 0,
  class: "fas fa-grip-vertical cursor-move drag"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_23 = {
  key: 1,
  class: "NewStepWaypoints__form"
}
const _hoisted_24 = { class: "NewStepWaypoints__title" }
const _hoisted_25 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_26 = {
  key: 0,
  class: "NewStepWaypoints__state mt-2"
}
const _hoisted_27 = { class: "state__message message--failed" }
const _hoisted_28 = {
  key: 1,
  class: "NewStepWaypoints__list"
}
const _hoisted_29 = { class: "list__actions" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_31 = {
  class: "list__wrapper",
  ref: "templatewindow"
}
const _hoisted_32 = {
  key: 0,
  class: "NewStepWaypoints__state mt-2"
}
const _hoisted_33 = { class: "state__message" }
const _hoisted_34 = {
  key: 2,
  class: "NewStepWaypoints__state mt-2"
}
const _hoisted_35 = { class: "state__message" }
const _hoisted_36 = {
  key: 2,
  class: "flex items-center justify-end mt-3"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_templates_actions = _resolveComponent("templates-actions")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_step_additional_services_ftl = _resolveComponent("step-additional-services-ftl")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_senders_list_item = _resolveComponent("senders-list-item")!
  const _component_receivers_list_item = _resolveComponent("receivers-list-item")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_templates_actions, {
          key: 0,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": false,
          loading: _ctx.actions_state.is_actions_loading,
          companyId: _ctx.companyId,
          "initial-value": _ctx.actions_state.initial_value,
          "is-sender": !_ctx.isSenderSelected,
          "is-receiver": _ctx.isSenderSelected,
          "load-by-sender-city-id": !_ctx.isInsideCity,
          "sender-city-id": _ctx.senderCityId,
          "receiver-city-id": _ctx.receiverCityId,
          "is-ftl": "",
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.onTemplateCreate,
          onUpdate: _ctx.onTemplateUpdate
        }, null, 8, ["is-create", "is-update", "loading", "companyId", "initial-value", "is-sender", "is-receiver", "load-by-sender-city-id", "sender-city-id", "receiver-city-id", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_4, " Выбранные пункты (" + _toDisplayString(_ctx.state.selected_templates.length) + ") ", 1),
          (!_ctx.completed || _ctx.isWaypoints)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " (вы можете изменять очередность пунктов) "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.completed && !_ctx.disabled && !_ctx.isWaypoints)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              class: "primary small text",
              onClick: _ctx.onUpdate
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createTextVNode(" Редактировать ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.opened || _ctx.isWaypoints)
        ? (_openBlock(), _createBlock(_component_draggable, {
            key: 0,
            list: _ctx.state.selected_templates,
            handle: ".drag",
            "item-key": "id",
            "component-data": {
                    tag: 'ul',
                    type: 'transition-group',
                    name: !_ctx.state.drag ? 'flip-list' : null,
                },
            animation: 200,
            move: _ctx.onDragMove,
            onStart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.drag = true)),
            onEnd: _ctx.onDragEnd
          }, {
            item: _withCtx(({ element, index }) => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(element.title), 1),
                  _createVNode(_component_cheap, { class: "primary small" }, {
                    default: _withCtx(() => [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Отправной пункт")
                          ], 64))
                        : (index === _ctx.state.selected_templates.length - 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" Конечный пункт ")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode("Промежуточный пункт")
                            ], 64))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(element.full_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, _toDisplayString(element.phone), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("span", _hoisted_19, _toDisplayString(element.full_address), 1)
                  ]),
                  (Boolean(element.warehouse_id))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                        (index === 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Самопривоз")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Самовывоз")
                            ], 64))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                ((!_ctx.completed && !_ctx.disabled) || _ctx.isWaypoints)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["flex items-center border-t pt-2 mt-2", {
                                'justify-between': index !== 0,
                                'justify-end': index === 0,
                            }])
                    }, [
                      (index !== 0)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                        : _createCommentVNode("", true),
                      _createVNode(_component_the_button, {
                        disabled: _ctx.disabled,
                        class: "red small text",
                        onClick: ($event: any) => (_ctx.onSelectedTemplateDelete(index))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22,
                          _createTextVNode(" Удалить ")
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ], 2))
                  : _createCommentVNode("", true),
                _createVNode(_component_step_additional_services_ftl, {
                  class: "mt-6",
                  opened: "",
                  toggle: "",
                  disabled: _ctx.disabled,
                  "initial-value": _ctx.getInitialServices(index),
                  onSubmit: (services) => _ctx.onAdditionalServicesSubmit(services, index),
                  onReset: ($event: any) => (_ctx.onAdditionalServicesReset(index))
                }, null, 8, ["disabled", "initial-value", "onSubmit", "onReset"])
              ])
            ]),
            _: 1
          }, 8, ["list", "component-data", "move", "onEnd"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.completed || _ctx.isWaypoints)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("p", _hoisted_24, [
            (!_ctx.opened)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Выбор пунктов")
                ], 64))
              : (_ctx.isSenderSelected)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Выберите конечный пункт")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode("Выберите отправной пункт")
                  ], 64))
          ]),
          (_ctx.opened)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_ctx.isFailedState)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("p", _hoisted_27, [
                        (_ctx.data_state.senders.is_failed)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Произошла ошибка при загрузке списка отправителей")
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.data_state.receivers.is_failed)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Произошла ошибка при загрузке списка получателей")
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_the_button, { class: "primary small mt-2" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Обновить ")
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_the_input, {
                          value: _ctx.state.search_query,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.search_query) = $event)),
                          disabled: _ctx.disabled,
                          placeholder: "Поиск по номеру телефона, адресу и названию",
                          onInput: _ctx.onTemplateSearch
                        }, null, 8, ["value", "disabled", "onInput"]),
                        _createVNode(_component_the_button, {
                          disabled: _ctx.disabled,
                          class: "primary small text mt-2 ml-3",
                          onClick: _ctx.startCreate
                        }, {
                          default: _withCtx(() => [
                            _hoisted_30,
                            (!_ctx.isSenderSelected)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Добавить отправной пункт")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Добавить пункт")
                                ], 64))
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data_state.senders.list, (sender) => {
                          return (_openBlock(), _createBlock(_component_senders_list_item, {
                            class: "NewStepWaypoints__item",
                            key: sender,
                            item: sender,
                            disabled: _ctx.disabled,
                            onSubmit: _ctx.onTemplateSelect,
                            onUpdate: _ctx.startUpdate,
                            onDeleted: _ctx.onTemplateDeleted
                          }, null, 8, ["item", "disabled", "onSubmit", "onUpdate", "onDeleted"]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data_state.receivers.list, (receiver) => {
                          return (_openBlock(), _createBlock(_component_receivers_list_item, {
                            class: "NewStepWaypoints__item",
                            key: receiver,
                            item: receiver,
                            disabled: _ctx.disabled,
                            selected: _ctx.checkIfTemplateSelected(receiver.id),
                            onSubmit: _ctx.onTemplateSelect,
                            onUpdate: _ctx.startUpdate,
                            onDeleted: _ctx.onTemplateDeleted
                          }, null, 8, ["item", "disabled", "selected", "onSubmit", "onUpdate", "onDeleted"]))
                        }), 128))
                      ], 512),
                      (_ctx.isEmptyState)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("p", _hoisted_33, [
                              (!_ctx.isSenderSelected)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("У выбранной компании нет отправных пунктов")
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("У выбранной компании нет конечных пунктов")
                                  ], 64))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])),
                (_ctx.isLoadingState)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createVNode(_component_loader, { class: "primary" }),
                      _createElementVNode("p", _hoisted_35, [
                        (_ctx.data_state.senders.is_loading)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Загрузка списка отправителей...")
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.data_state.receivers.is_loading)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Загрузка списка получателей...")
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ((_ctx.opened && !_ctx.completed) || _ctx.isWaypoints)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createVNode(_component_the_button, {
            disabled: Boolean(_ctx.disabled || _ctx.isSubmitDisabled),
            class: "primary small",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_37,
              _createTextVNode(" Завершить выбор пунктов ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}